export type ProposalType = 'standard' | 'custom';

export interface ProposalFormData {
	proposalType: ProposalType;
	industry?: string;
	special?: string;
	prospectName?: string;
	prospectTitle?: string;
	companyName?: string;
	websiteAddon?: string;
}

export interface ProposalGenerationResponse {
	success: boolean;
	fileId?: string;
	pdfUrl?: string;
	fileName?: string;
	error?: string;
}

export const INDUSTRIES = [
	{ value: 'Insurance', label: 'Insurance' },
	{ value: 'Financial', label: 'Financial' },
	{ value: 'Legal', label: 'Legal' },
	{ value: 'Non-Profit', label: 'Non-Profit' },
	{ value: 'Home Service', label: 'Home Service' },
	{ value: 'Accounting', label: 'Accounting' },
	{ value: 'Health Services', label: 'Health Services' },
	{ value: 'Other', label: 'Generic' },
] as const;

export const WEBSITE_ADDONS = [
	{ value: '', label: 'None' },
	{ value: 'FIN Compliance', label: 'FIN Compliance' },
	{ value: 'Translations', label: 'Translations' },
	{ value: 'ADA Compliance', label: 'ADA Compliance' },
] as const;
